import { type ReactElement } from 'react';
import { LANGUAGES, useTranslation } from '@/lib/i18n';
import { cn } from '@/lib/utils';

// Instant toggle per requirements §19; the choice survives a reload.
export function LanguageToggle(): ReactElement {
  const { language, setLanguage } = useTranslation();
  return (
    <div className="flex shrink-0 overflow-hidden rounded-full border text-xs font-semibold">
      {LANGUAGES.map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => setLanguage(option)}
          aria-pressed={option === language}
          className={cn(
            'px-1.5 py-1 uppercase sm:px-2.5',
            option === language ? 'bg-primary text-primary-foreground' : 'text-muted-foreground',
          )}
        >
          {option}
        </button>
      ))}
    </div>
  );
}
